import { useContext, useEffect, useState } from "react";
import queryString from "query-string";
import Loader from "./Loader";
import QuestContext from "../../../../components/QuestWrapper";
import LoginApi from "./loginApi";
import { GoogleLoginProps } from "./logintypes";
import { SecondaryButton } from "../../../../components/Modules/SecondaryButton";
import { google2 } from "../../../../assets/images";
import General from "../../../../general";

const GoogleLogin: React.FC<GoogleLoginProps> = ({
  entityId,
  redirectUri,
  redirectURL,
  googleClientId,
  apiSecret,
  apiKey,
  onSubmit,
  googleButtonText,
  onError,
  themeManager,
}) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const { setUser, apiType } = useContext(QuestContext.Context);
  let GeneralFunctions = new General("mixpanel", apiType);

  const loginApi = new LoginApi(apiType);
  const params = queryString.parse(window.location.search);
  const googleCode = params.code as string;

  const isValidURL = (url: string) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  }

  useEffect(() => {
    if (googleCode) {
      handleGoogleAuth(googleCode);
    }
  }, [googleCode]);

  const handleGoogleAuth = async (code: string) => {
    try {
      setShowLoader(true);
      const response = await loginApi.googleLogin(code, redirectUri, entityId, {
        apiKey,
        apiSecret,
      });

      if (response.success) {
        if (onSubmit) {
          onSubmit({
            userId: response.userId,
            token: response.token,
            userCredentials: response.credentials,
            refreshToken: response.refreshToken,
            newUser: response.newUser
          });
        }

        setUser({
          userId: response.userId,
          token: response.token,
          userCredentials: response.credentials,
          refreshToken: response.refreshToken,
        });

        if (isValidURL(redirectURL)) {
          window.location.href = redirectURL;
        }
      } else {
        onError?.({
          error: response.error || "Google login failed",
          isGoogle: true,
        });
      }
    } catch (error) {
      console.error("Google login error:", error);
      GeneralFunctions.captureSentryException(error);
      onError?.({
        error: "Failed to complete Google login",
        isGoogle: true,
      });
    } finally {
      setShowLoader(false);
    }
  };

  const handleGoogleLoginClick = () => {
    loginApi.trackEvent("quest_login_google_btn_clicked", "quest_login");

    try {
      const googleAuthUrl = loginApi.initiateGoogleLogin(
        googleClientId,
        redirectUri
      );
      window.location.href = googleAuthUrl;
    } catch (error) {
      onError?.({
        error: "Google Client ID is required for Google login",
        isGoogle: true,
      });
    }
  };

  return (
    <div className="q-google-login-btn" style={{ width: "100%" }}>
      <div style={{ position: "relative" }}>
        {showLoader && <Loader />}

        <a
          style={{ textDecoration: "none", color: "red" }}
          onClick={handleGoogleLoginClick}
        >
          <SecondaryButton style={themeManager.getSecondaryButtonStyles()} className="google-login-btn">
            <p>{googleButtonText || "Sign in with Google"}</p>
            <img className="ml-auto" src={google2} alt="google-logo" />
          </SecondaryButton>
        </a>
      </div>
    </div>
  );
};

export default GoogleLogin;
